import UploadPlanningTemplateHandler from "./upload_template_handler.coffee"
import ConfigurePrePanningComments from './configure_pre_planing_comments.js'
import CopyStepPlannings from './copy_step_plannings.js'

$(document).on 'turbolinks:load', ->
  new UploadPlanningTemplateHandler().call()
  ConfigurePrePanningComments.handler_events()
  CopyStepPlannings.handleEvents()